import "Layouts/default";

$(function () {
    $(".js-form-contact").validate({
        rules: {
            name: {
                minlength: 3,
            },
            message: {
                minlength: 5,
            },
        },
        errorPlacement: function (error, element) {
            if (element.attr("type") && element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function (form) {
            Form.ajaxPost(
                form,
                function (data) {
                    var msg = data.msg.format;

                    if (!msg) {
                        msg = data.msg;
                    }

                    $(".js-contact-error").hide();

                    if (!data.status) {
                        $(".js-contact-error").text(msg).slideDown();
                    } else {
                        $(form).slideUp(250, function () {
                            $(".js-contact-success").text(msg).slideDown(250);
                        });
                    }

                    rEvent.dispatch("Recaptcha.execute");
                },
                "json"
            );
        },
    });
});
